import './Transaction.css';

import React, {useState, useRef } from 'react'
import { Sidenav } from '../SideNav/Sidenav';
import { CustomNavbar } from '../CustomNavbar/customnabar';
import { BsSearch } from 'react-icons/bs'
import axios from 'axios';
import { conn } from '../../Utilt/conn';
import { Fade } from "react-awesome-reveal";
import transact from '../../Assets/ICONS/transact.png'
import Loader from "../Loader/Loader";
import Layout from '../../ReuseComponent/Layout/Layout';
import { useNavigate } from 'react-router-dom';


const { FormatMoney } = require('format-money-js');


const fm = new FormatMoney({
    decimals: 2
});

function Transaction() {
    
    const ref = useRef();
    
    const token = window.localStorage.getItem("token")
    const refreshtoken = window.localStorage.getItem("refreshtoken")
    const navigate = useNavigate()
    
    const config = {
            headers: {
                "Content-Type": "application/json",
                'Access-Control-Allow-Origin': '*',
                'token': token,
                'refreshtoken': refreshtoken
            }
        };

    const Resinput = document.querySelector(".search");


    const SearchEnter = (e) => {
        setSearchInput(e.target.value);
        Resinput.addEventListener("keypress", async (event) => {
            if (event.key === 'Enter') {
                setLoading(true);
                searchTransaction()
            }
        }, { once: true })


    }

    const searchTransaction = async () => {
        setLoading(true);
        await axios.post(conn + "/admin/account/single_transaction_from_user", {
            "input": search_input,
            "page": "1",
            "limit": "2"
        }, config).then((value) => {
            console.log(value);
            setTransaction(value.data.data);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
            setLoading(false);
            if (error.response.status === 401) navigate('/login')

        })

    }


    const [transaction, setTransaction] = useState([]);
    const [search_input, setSearchInput] = useState("");
    const [isloading, setLoading] = useState(false);

    return (
        <Layout label="Transactions">
            <section>

                <div className="card">

                    <div className='in'>

                        <p><span>Total Customers</span></p>

                        <Fade duration={1000}><p style={{ margin: "1vh 0vh", fontSize: "24px", color: "black" }}>{transaction.length}</p></Fade>

                        <p style={{ fontSize: "13px", color: "#d1d1d1" }}>These are the total number of transactions</p>

                    </div>

                </div>

                <Fade duration={1000}>
                <div className="search-area">

                    <input type="text" className="search" ref={ref} value={search_input} onChange={(e) => SearchEnter(e)}  onClick={(e) => SearchEnter(e)} onFocus={(e) => SearchEnter(e)} placeholder='Search for transaction with reference' />

                    <span style={{ cursor: "pointer" }} onClick={() => searchTransaction()} ><BsSearch /></span>

                </div>
                </Fade>

                <div className='table'>

                    {(transaction.length !== 0 && !isloading) ? <table>


                        <thead>
                            <td>Narration</td>
                            <td>Amount</td>
                            <td>Date</td>
                            <td>Transaction ref</td>
                            <td>Status</td>
                        </thead>

                        {

                            transaction.map((dt, key) =>

                                <tr key={key}>
                                    <td><Fade>{dt.from_name + "  TO  " + dt.to_name}</Fade></td>
                                    <td style={{ color: "green" }}><Fade><span className="numba">{fm.from(parseFloat(dt.amt / 100), { symbol: '' })}</span></Fade></td>
                                    <td className="numba"><Fade>{dt.created_on.substring(0, 10)}</Fade></td>
                                    <td><Fade>{dt.transaction_ref}</Fade></td>
                                    <td><Fade><span style={{ color: "green" }}>Approved</span></Fade></td>
                                </tr>

                            )

                        }


                    </table> : (!isloading ? <div className='empty'>

                        <img src={transact} />
                        <p style={{ textAlign: "center", margin: "1vh 0vh", fontSize: "14px" }}>There are no existing trasactions</p>

                    </div>: <>{isloading && <Loader />}</>)}

                </div>

            </section>
        </Layout>
        
    )
}

export default Transaction

